import { ApiError } from '@/lib/pillarApi';
import {
    CredentialDeleteConflictResponseSchema,
    type CredentialUsageListItem,
} from '@pillar-portal/api-types';

export function parseCredentialDeleteConflictUsages(
    error: unknown
): CredentialUsageListItem[] | null {
    if (!(error instanceof ApiError)) {
        return null;
    }
    const parseResult = CredentialDeleteConflictResponseSchema.safeParse(error.body);
    if (!parseResult.success) {
        return null;
    }
    return parseResult.data.usages;
}
